<template>
    <!-- 和暦選択入力 -->
    <div style="display: flex; gap: 4px;">
        <button style="display: flex; gap: 0px; background: none; border: none; margin-right: 0px;" @click="swap">
            <svg yu-icon="sort" size="12"></svg> {{ IsWareki ? "和暦" : "西暦" }}
        </button>

        <template v-if="IsWareki">
            <select v-model="Input.prefix" :disabled="disabled" @change="changed" style="width: 50px">
                <option :value="''">--</option>
                <option v-for="x in warekis" :value="x.wareki" :key="x.wareki">{{ x.wareki }}</option>
            </select>

            <select v-model="Input.year" :disabled="disabled" @change="changed" style="width: 40px">
                <option :value="0">--</option>
                <option v-for="i in SelectItems.years" :value="i" :key="i">{{ i }}年</option>
            </select>
        </template>
        
        <template v-else>
            <select v-model="Input.year" :disabled="disabled" @change="changed" style="width: 60px">
                <option :value="0">----</option>
                <option v-for="i in SelectItems.years" :value="i" :key="i">{{ i }}年</option>
            </select>
        </template>


        <select v-model="Input.month" :disabled="disabled" @change="changed" style="width: 40px">
            <option :value="0">--</option>
            <option v-for="i in SelectItems.months" :value="i" :key="i">{{ i }}月</option>
        </select>

        <select v-model="Input.day" :disabled="disabled" @change="changed" style="width: 40px">
            <option :value="0">--</option>
            <option v-for="i in SelectItems.days" :value="i" :key="i">{{ i }}日</option>
        </select>
    </div>
</template>

<script>
import "../assets/api/tableTypes"
import utility from '../assets/utility'

export default {
    props: {
        disabled: {
            default: false,
        },
        value: {
            default: ()=> utility.getNullDate(),
        },
        minYear:{
            type: Number,
            default: 1868,
            //1868=明治元年
            //NullDateより小さい値は設定しない
        },
        maxYear:{
            type: Number,
            default: ()=> new Date().getFullYear()+10,
        },
        warekis: {
            default: []
        },
    },
    data() {
        return {
            IsWareki: false,
            Input:{
                prefix: "",
                year: 0,
                month: 0,
                day: 0,
            },
            SelectItems:{
                years: [],
                months: [1,2,3,4,5,6,7,8,9,10,11,12],
                days: [],
            },
        }
    },
    watch:{
        value:{
            handler(v){
                this.setValue(v)
            },
            immediate: true,
        }
    },
    mounted(){
        this.resetYearItems()
    },
    methods: {
        swap(){
            this.IsWareki = !this.IsWareki
            this.Input = (this.IsWareki) ? this.toWareki(this.Input) : this.toSeireki(this.Input)
            this.changed()
        },
        changed(){
            this.resetYearItems()
            if(this.SelectItems.years.indexOf(this.Input.year) < 0) this.Input.year=0
            if(this.SelectItems.months.indexOf(this.Input.month) < 0) this.Input.month=0
            this.resetDayItems()
            if(this.SelectItems.days.indexOf(this.Input.day) < 0) this.Input.day=0
            
            let v = this.getValue()
            if(v.getTime() != this.value.getTime()){
                this.$emit("input", v)
            }
        },
        resetYearItems(){
            let start = 0
            let end = -1
            let opt = []

            if(this.IsWareki){
                let waIdx = this.warekis.findIndex(x=>x.wareki == this.Input.prefix)
                if(waIdx >= 0){
                    let first = Math.max(this.minYear, this.warekis[waIdx].startOn.getFullYear())
                    let last = this.maxYear

                    if(waIdx < this.warekis.length -1){
                        let d = new Date(this.warekis[waIdx+1].startOn.getTime())
                        d.setDate(d.getDate()-1)
                        last = Math.min(last, d.getFullYear())
                    }
                    start = 1
                    end = last - first + 1
                }
                for(let i=start; i<=end; i++) opt.push(i)
            }else{
                start = this.minYear
                end = this.maxYear
                for(let i=end; i>=start; i--) opt.push(i)
            }

            if(opt.join(",") != this.SelectItems.years.join(",")){
                this.SelectItems.years = opt
            }
        },
        resetDayItems(){
            let v = this.Input
            if(this.IsWareki){
                v = this.toSeireki(this.Input)
            }

            let opt = []
            let last = this.getLastDay(v.year, v.month)
            for(let i=0; i<last; i++) opt.push(i+1)

            if(opt.join(",") != this.SelectItems.days.join(",")){
                this.SelectItems.days = opt
            }
        },
        toWareki(v){
            let wa = null
            if(v.year>0 && v.month >0 && v.day >0){
                let d = new Date(v.year, v.month-1, v.day)
                wa = this.warekis.map(x=>x)
                    .sort((x,y)=>y.startOn.getTime()-x.startOn.getTime())
                    .find(x=>x.startOn.getTime() <= d.getTime())
            }
            return {
                prefix: wa ? wa.wareki : "",
                year: (wa && v.year>0) ? v.year - wa.startOn.getFullYear() + 1 : 0,
                month: v.month,
                day: v.day,
            }
        },
        toSeireki(v){
            let wa = this.warekis.find(x=>x.wareki==v.prefix)
            return {
                prefix: "",
                year: (wa && v.year>0) ? wa.startOn.getFullYear() + v.year - 1 : 0,
                month: v.month,
                day: v.day,
            }
        },
        getLastDay(year, month){
            if(year<=0 || month<=0) return 0

            function isLeapYear(year) {
                if (year % 4 != 0) return false
                if (year % 100 == 0 && year % 400 != 0) return false
                return true
            }
            let v = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ][month-1]
            return (month==2 && isLeapYear(year)) ? v+1 : v
        },
        getValue(){
            let v = this.IsWareki ? this.toSeireki(this.Input) : this.Input

            if(v.year <= 0 || v.month <= 0 || v.day == 0){
                return utility.getNullDate()
            }else{
                return new Date(v.year, v.month-1, v.day)
            }
        },
        setValue(d){
            if(d.getTime() == this.getValue().getTime()) return

            let isNull = d.getTime() == utility.getNullDate().getTime()
            let v = {
                year: isNull ? 0 : d.getFullYear(),
                month: isNull ? 0 : d.getMonth()+1,
                day: isNull ? 0 : d.getDate(),
            }
            this.Input = this.IsWareki ? this.toWareki(v) : v
            this.changed()
        }
    },
}
</script>

<style scoped>
    svg{
        color: gray;
    }
    button:active > svg{
        color: deepskyblue;
    }
    select{
        background: none;
        border: none;
        appearance: none;
        border-bottom: 1px solid darkgray;
        padding-left: 2px;
    }
</style>